'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Verifier = require('../Verifier');

var _Verifier2 = _interopRequireDefault(_Verifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextTypes = {
  _userPermissions: _propTypes2.default.object
};

var Cannot = function Cannot(props, context) {
  var render = props.render;

  return _react2.default.createElement(_Verifier2.default, _extends({}, props, {
    render: render,
    condition: context._userPermissions.isActionDenied
  }));
};

Cannot.propTypes = _Verifier.propTypes;
Cannot.contextTypes = contextTypes;

exports.default = Cannot;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/user-permissions/lib/components/Cannot.js
 ** module id = 257
 ** module chunks = 0
 **/